import CtaButtonGroup, { CtaType } from '@/components/molecules/CtaButtonGroup';
import Image from 'next/image';
import React from 'react';

interface CertificateProps {
  name: string;
  imageUrl: string;
  ctas: CtaType[];
  description: string;
  width?: number;
  height?: number;
  title: string;
}

const Certificate: React.FC<CertificateProps> = ({ name, imageUrl, description, ctas, width, height, title }) => {
  return (
    <div className="relative w-full overflow-hidden bg-white py-6 sm:py-10">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row items-start justify-between gap-8">
          <div className="w-full md:w-1/2 flex flex-col gap-4">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 max-w-[25ch] after:content-['\a'] after:whitespace-pre">
              {title}
            </h2>
            <p className="text-[14px] leading-[20px] text-[#4A4A4A] font-normal font-sans max-w-[25ch] md:max-w-full">
              {description}
            </p>
            <div>
              <CtaButtonGroup align="sm:left" ctas={ctas} affiliateButton={true} />
            </div>
          </div>
          <div className="w-full md:w-1/2 flex justify-center items-center">
            <div className="relative w-full justify-center items-center">
              <Image
                src={imageUrl}
                alt={name}
                width={width}
                height={height}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificate;